export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=400dcfebdcfb8390fb9b75e1cbf21d2052df09f3fe&name=revalidateCommunity!'